import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { AppRoutes } from './routes';
import AppLayout from './components/layout/AppLayout';
import { useSupabaseAuth } from './hooks/useSupabaseAuth';
import ToastContainer from './components/ui/ToastContainer';
import { useToast } from './hooks/useToast';
import { useDeepLinks } from './hooks/useDeepLinks';

const AppContent: React.FC = () => {
  useSupabaseAuth();
  useDeepLinks();
  const { toasts, removeToast } = useToast();

  return (
    <AppLayout>
      <AppRoutes />
      <ToastContainer toasts={toasts} onRemoveToast={removeToast} />
    </AppLayout>
  );
};

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </Provider>
  );
};

export default App;